<template>
  <div class="page">
    <div class="header-menu">
      <navBar v-model="objSave"></navBar>
    </div>
    <div class="page-content">
      <div class="VerificationLogin">
        <div class="VerificationLogin-title">{{ $t("system.DynamicPasswordLogin") }}</div>
        <div class="VerificationLogin-wrapper">
          <div class="VerificationLogin-item">
            <input v-model="model.UserAct" type="text" :placeholder="$t('placeholders.RegisterPhone')" />
          </div>
          <div class="border_bottom"></div>
          <div class="VerificationLogin-item">
            <input v-model="model.ValidCode" type="text" style="height: 0.32rem;" :placeholder="$t('placeholders.VerificationCode')" />
            <img :src="checkImageUrl" class="valid-image" @click="ReloadImage" />
          </div>
          <div class="border_bottom"></div>
          <div class="VerificationLogin-item">
            <div>
              <input type="text" :placeholder="$t('placeholders.DynamicCode')" />
            </div>
            <label v-if="judgeCode" @click="sendCode">{{ textCode }}</label>
            <label v-else :style="{ color: !judgeCode ? '#666' : '' }">{{ textCode }}</label>
          </div>
          <div class="border_bottom"></div>
        </div>
        <div class="login-btn" @click="Save">{{ $t("system.LoginTxt") }}</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }

  .page-content {
    background-color: #fff;
  }

  .VerificationLogin-title {
    padding-top: 0.266rem;
    color: #333;
    font-size: 0.478rem;
    width: 100%;
    text-align: center;
  }

  .VerificationLogin-wrapper {
    padding: 0 10%;
  }

  .VerificationLogin-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 1.197rem;
  }

  .VerificationLogin-item input {
    height: 0.798rem;
    border: 0;
    width: 100%;
    font-size: 0.399rem;
  }

  .VerificationLogin-item label {
    font-size: 0.399rem;
    color: #12a3ff;
    padding: 0.133rem 0.266rem;
  }

  .VerificationLogin-item input:focus {
    outline: 0;
  }

  .border_bottom:after {
    background-color: #f5f5f5;
  }

  .login-btn {
    background: #12a3ff;
    color: #fff;
    padding: 0.266rem 0;
    margin: 0 10%;
    margin-top: 0.798rem;
    border-radius: 0.106rem;
    text-align: center;
  }
</style>
<script>
  import sideService from "@/service/sideService";
  import navBar from "../modules/navBar.vue";
  export default {
    data() {
      return {
        checkImageUrl: "",
        objSave: {
          centerTitle: "",
        },
        textCode: this.$root.$t("system.SendDynamicCode"),
        model: {
          UserAct: "",
          UserPwd: "",
          ValidCode: "",
        },
        judgeCode: true,
        setInterval: null,
      };
    },
    mounted() {
      let __self = this;
      __self.ReloadImage();
    },
    methods: {
      ReloadImage() {
        let __self = this;
        __self.checkImageUrl = sideService.getValidImageUrl();
      },
      sendCode() {
        let __self = this;
        if (__self.model.UserAct == "") {
          return $utils.fail(__self.$t("share.fail.VerificationCode"), "fail");
        }
        if (__self.model.ValidCode == "") {
          return $utils.fail(__self.$t("share.fail.DynamicCode"), "fail");
        }
        if (__self.judgeCode) {
          let $time = 60;
          __self.judgeCode = false;
          __self.setInterval = setInterval(run, 1000);
          function run() {
            __self.textCode = "(" + __self.$t("system.Sent") + --$time + ")";
            if ($time <= 0) {
              clearInterval(__self.setInterval);
              __self.textCode = __self.$t("system.SendDynamicCode");
              __self.judgeCode = true;
            }
          }
        }
      },
      Save() {
        let __self = this;
        if (__self.model.UserAct == "") {
          __self.ReloadImage();
          return $utils.fail(__self.$t("share.fail.RegisterPhone"), "fail");
        }
      },
    },
    components: {
      navBar,
    },
  };
</script>
